import { ReactNode, useEffect } from "react";
import { fetchAndActivate } from "firebase/remote-config";
import remoteConfig from '@/firebase/remoteConfig';

const AppConfigProvider = ({ children }: { children: ReactNode }) => {
    useEffect(() => {
        (async () => {
          await fetchAndActivate(remoteConfig);
        })()
    }, [])

    return children;
}

export default AppConfigProvider;
